export default "__VITE_ASSET__Dc$MvG1Q__"